(ns frontend.view.reports.custom.view-2
  (:require
   [frontend.view.reports.custom.alj-2 :as alj-2]
   [frontend.view.reports.custom.diamond-edge-ventures-charts :as diamond-edge-ventures-charts]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn custom-view
  [args]
  [:div.py-3
   (when (tenant-customizations/alj?)
     [alj-2/view args])
   (when (tenant-customizations/diamond-edge-ventures?)
     [diamond-edge-ventures-charts/view])])
